// Client build versions for Report It (MV-1396).
//
// The Hub version is a build-time constant (env). The Spatial Manager version
// is fetched once at startup (MytaverseProvider's GET api/version) and was only
// logged; this module-scoped store keeps it so the Report It dialog can attach
// it to the report — same in-memory, page-lifetime pattern as the other
// reportIt stores (rtcStatsBuffer / connectionStateStore).

import { env } from 'env';

let spatialManagerVersion: string | undefined;

/** Stash the spatial-manager service version seen at startup. */
export function setSpatialManagerVersion(version: string | undefined | null): void {
  spatialManagerVersion =
    typeof version === 'string' && version.trim().length > 0
      ? version.trim()
      : undefined;
}

export function getSpatialManagerVersion(): string | undefined {
  return spatialManagerVersion;
}

/** The web Hub build version (build-time env constant). */
export function getHubVersion(): string | undefined {
  const version = env.REACT_APP_HUB_VERSION;

  return typeof version === 'string' && version.length > 0 ? version : undefined;
}
